define('Home.Extension', [
  'Home',
  'Home.ProductGallery.View',

  'Backbone',
  'jQuery',
  'Utils',
  'underscore'
], function (
  Home,
  HomeProductGalleryView,

  Backbone,
  jQuery,
  Utils,
  _
) {
  'use strict';

  _.extend(Home, {
    mountToApp: _.wrap(Home.mountToApp, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      var container = arguments[1];
      var layout = container.getComponent('Layout');

      layout.addChildView('Product.Gallery', function () {
        var view = new HomeProductGalleryView({
          application: container
        });

        return view;
      });

      return context;
    })
  });
});
